export const meals = [
  {
    id: 1,
    name: 'Grilled Salmon with Quinoa',
    description: 'Wild-caught salmon with organic quinoa, roasted vegetables and lemon herb sauce',
    calories: 520,
    price: 12.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20grilled%20salmon%20fillet%20with%20quinoa%20and%20colorful%20roasted%20vegetables%20on%20white%20plate%2C%20garnished%20with%20fresh%20herbs%20and%20lemon%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20restaurant%20quality%20presentation%2C%20vibrant%20colors&width=600&height=450&seq=meal-001&orientation=landscape',
    tags: ['High-Protein', 'Gluten-Free'],
    chef: 'Chef Maria',
  },
  {
    id: 2,
    name: 'Mediterranean Chicken Bowl',
    description: 'Herb-marinated chicken breast with hummus, fresh vegetables and tahini dressing',
    calories: 480,
    price: 11.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20mediterranean%20chicken%20bowl%20with%20hummus%2C%20cherry%20tomatoes%2C%20cucumbers%2C%20olives%20and%20tahini%20sauce%20on%20white%20plate%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20colorful%20fresh%20ingredients%2C%20restaurant%20presentation&width=600&height=450&seq=meal-002&orientation=landscape',
    tags: ['High-Protein', 'Gluten-Free'],
    chef: 'Chef Thomas',
  },
  {
    id: 3,
    name: 'Vegan Buddha Bowl',
    description: 'Roasted chickpeas, sweet potato, avocado, kale and tahini dressing',
    calories: 420,
    price: 10.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20colorful%20vegan%20buddha%20bowl%20with%20roasted%20chickpeas%2C%20sweet%20potato%20cubes%2C%20avocado%20slices%2C%20fresh%20kale%20and%20tahini%20drizzle%20on%20white%20plate%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20vibrant%20plant%20based%20meal&width=600&height=450&seq=meal-003&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free'],
    chef: 'Chef Anna',
  },
  {
    id: 4,
    name: 'Beef Teriyaki with Rice',
    description: 'Tender beef strips in teriyaki sauce with jasmine rice and stir-fried vegetables',
    calories: 580,
    price: 13.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20beef%20teriyaki%20with%20jasmine%20rice%20and%20colorful%20stir%20fried%20vegetables%20on%20white%20plate%2C%20glossy%20teriyaki%20sauce%2C%20garnished%20with%20sesame%20seeds%20and%20green%20onions%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20asian%20cuisine%20presentation&width=600&height=450&seq=meal-004&orientation=landscape',
    tags: ['High-Protein'],
    chef: 'Chef David',
  },
  {
    id: 5,
    name: 'Vegetarian Pasta Primavera',
    description: 'Whole wheat pasta with seasonal vegetables in light tomato basil sauce',
    calories: 450,
    price: 10.49,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20whole%20wheat%20pasta%20primavera%20with%20colorful%20seasonal%20vegetables%20in%20light%20tomato%20basil%20sauce%20on%20white%20plate%2C%20garnished%20with%20fresh%20basil%20leaves%20and%20parmesan%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20italian%20cuisine%20presentation&width=600&height=450&seq=meal-005&orientation=landscape',
    tags: ['Vegetarian'],
    chef: 'Chef Sofia',
  },
  {
    id: 6,
    name: 'Thai Green Curry',
    description: 'Aromatic green curry with chicken, vegetables and jasmine rice',
    calories: 510,
    price: 12.49,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20thai%20green%20curry%20with%20chicken%20and%20vegetables%20served%20with%20jasmine%20rice%20on%20white%20plate%2C%20vibrant%20green%20curry%20sauce%2C%20garnished%20with%20fresh%20basil%20and%20red%20chili%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20thai%20cuisine%20presentation&width=600&height=450&seq=meal-006&orientation=landscape',
    tags: ['High-Protein', 'Gluten-Free'],
    chef: 'Chef Maria',
  },
  {
    id: 7,
    name: 'Lentil Power Bowl',
    description: 'Protein-rich lentils with roasted vegetables, spinach and tahini',
    calories: 390,
    price: 9.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20lentil%20power%20bowl%20with%20roasted%20vegetables%2C%20fresh%20spinach%20and%20tahini%20drizzle%20on%20white%20plate%2C%20colorful%20healthy%20ingredients%2C%20garnished%20with%20seeds%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20plant%20based%20protein%20meal&width=600&height=450&seq=meal-007&orientation=landscape',
    tags: ['Vegan', 'High-Protein'],
    chef: 'Chef Anna',
  },
  {
    id: 8,
    name: 'Grilled Turkey with Sweet Potato',
    description: 'Lean turkey breast with roasted sweet potato and green beans',
    calories: 470,
    price: 11.49,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20grilled%20turkey%20breast%20with%20roasted%20sweet%20potato%20wedges%20and%20green%20beans%20on%20white%20plate%2C%20garnished%20with%20fresh%20herbs%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20healthy%20lean%20protein%20meal%20presentation&width=600&height=450&seq=meal-008&orientation=landscape',
    tags: ['High-Protein', 'Gluten-Free'],
    chef: 'Chef Thomas',
  },
  {
    id: 9,
    name: 'Mushroom Risotto',
    description: 'Creamy arborio rice with wild mushrooms and parmesan',
    calories: 440,
    price: 11.99,
    image: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20creamy%20mushroom%20risotto%20with%20wild%20mushrooms%20and%20parmesan%20on%20white%20plate%2C%20garnished%20with%20fresh%20thyme%20and%20truffle%20oil%20drizzle%2C%20top%20view%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20italian%20comfort%20food%20presentation&width=600&height=450&seq=meal-009&orientation=landscape',
    tags: ['Vegetarian'],
    chef: 'Chef Sofia',
  },
];